// 预处理页面路由
export default {
  path: '/preprocessing/index',
  name: 'PreprocessingIndex',
  component: () => import(/* webpackChunkName: 'preprocessing' */ '@/pages/preprocessingPage')
};
